import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type EditProfileViewKollegeUserFragment = { __typename?: 'KollegeUser', id: string, isAntiSocial?: boolean | null, email?: { __typename?: 'KollegeUserEmail', email: string, isActivated: boolean } | null, profile?: { __typename?: 'KollegeUserProfile', familyName: string, familyNameKana: string, givenName: string, givenNameKana: string, birthDate: TimeString, phoneNumber?: string | null } | null, address?: { __typename?: 'KollegeUserAddress', postalCode: string, prefecture: string, city: string, town: string, building: string } | null };

export type EditProfileViewUpdateKollegeUserMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  isAntiSocial?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type EditProfileViewUpdateKollegeUserMutation = { __typename?: 'Mutation', updateKollegeUser?: { __typename?: 'KollegeUser', id: string, isAntiSocial?: boolean | null } | null };

export type EditProfileViewUpdateKollegeUserProfileAndAddressMutationVariables = Types.Exact<{
  input: Types.UpdateKollegeUserProfileAndAddressInput;
}>;


export type EditProfileViewUpdateKollegeUserProfileAndAddressMutation = { __typename?: 'Mutation', updateKollegeUserProfileAndAddress?: { __typename?: 'UpdateKollegeUserProfileAndAddressResponse', success: boolean } | null };

export const EditProfileViewKollegeUserFragmentDoc = gql`
    fragment EditProfileViewKollegeUser on KollegeUser {
  id
  isAntiSocial
  email {
    email
    isActivated
  }
  profile {
    familyName
    familyNameKana
    givenName
    givenNameKana
    birthDate
    phoneNumber
  }
  address {
    postalCode
    prefecture
    city
    town
    building
  }
}
    `;
export const EditProfileViewUpdateKollegeUserDocument = gql`
    mutation EditProfileViewUpdateKollegeUser($id: ID!, $isAntiSocial: Boolean) {
  updateKollegeUser(input: {id: $id, isAntiSocial: {value: $isAntiSocial}}) {
    id
    isAntiSocial
  }
}
    `;

/**
 * __useEditProfileViewUpdateKollegeUserMutation__
 *
 * To run a mutation, you first call `useEditProfileViewUpdateKollegeUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileViewUpdateKollegeUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditProfileViewUpdateKollegeUserMutation({
 *   variables: {
 *     id: // value for 'id'
 *     isAntiSocial: // value for 'isAntiSocial'
 *   },
 * });
 */
export function useEditProfileViewUpdateKollegeUserMutation(options: VueApolloComposable.UseMutationOptions<EditProfileViewUpdateKollegeUserMutation, EditProfileViewUpdateKollegeUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditProfileViewUpdateKollegeUserMutation, EditProfileViewUpdateKollegeUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditProfileViewUpdateKollegeUserMutation, EditProfileViewUpdateKollegeUserMutationVariables>(EditProfileViewUpdateKollegeUserDocument, options);
}
export type EditProfileViewUpdateKollegeUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditProfileViewUpdateKollegeUserMutation, EditProfileViewUpdateKollegeUserMutationVariables>;
export const EditProfileViewUpdateKollegeUserProfileAndAddressDocument = gql`
    mutation EditProfileViewUpdateKollegeUserProfileAndAddress($input: UpdateKollegeUserProfileAndAddressInput!) {
  updateKollegeUserProfileAndAddress(input: $input) {
    success
  }
}
    `;

/**
 * __useEditProfileViewUpdateKollegeUserProfileAndAddressMutation__
 *
 * To run a mutation, you first call `useEditProfileViewUpdateKollegeUserProfileAndAddressMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useEditProfileViewUpdateKollegeUserProfileAndAddressMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useEditProfileViewUpdateKollegeUserProfileAndAddressMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useEditProfileViewUpdateKollegeUserProfileAndAddressMutation(options: VueApolloComposable.UseMutationOptions<EditProfileViewUpdateKollegeUserProfileAndAddressMutation, EditProfileViewUpdateKollegeUserProfileAndAddressMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<EditProfileViewUpdateKollegeUserProfileAndAddressMutation, EditProfileViewUpdateKollegeUserProfileAndAddressMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<EditProfileViewUpdateKollegeUserProfileAndAddressMutation, EditProfileViewUpdateKollegeUserProfileAndAddressMutationVariables>(EditProfileViewUpdateKollegeUserProfileAndAddressDocument, options);
}
export type EditProfileViewUpdateKollegeUserProfileAndAddressMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<EditProfileViewUpdateKollegeUserProfileAndAddressMutation, EditProfileViewUpdateKollegeUserProfileAndAddressMutationVariables>;